
import { Component, Vue } from 'vue-property-decorator'

import { Whitelabel } from '@/types/Whitelabel'
import whitelabelModule from '@/store/whitelabel'

import ContentList from '@/components/listView/ContentList.vue'
import WhitelabelEditor from '@/components/whitelabel/WhitelabelEditor.vue'
import { ListType } from '@/utils/enums'

@Component({
  name: 'WhitelabelList',
  components: {
    ContentList,
    WhitelabelEditor
  }
})
class WhitelabelList extends Vue {
  private listType = ListType

  private get storeModule() {
    return whitelabelModule
  }

  private get whitelabels(): Whitelabel[] {
    return whitelabelModule.whitelabels
  }

  private get headers() {
    return [
      {
        text: 'Name',
        value: 'name'
      },
      { text: 'Firmenname', value: 'legalName' },
      { text: 'Slug', value: 'slug' },
      { text: 'E-Mail', value: 'email' },
      { text: 'Telefon', value: 'phone' },
      { text: 'Status', value: 'active' }
    ]
  }

  private setWhitelabel(wl: Whitelabel) {
    whitelabelModule.setWhitelabel(wl)
    this.$router.push({ name: 'WhitelabelDetail', params: { wid: wl._id } })
  }
}

export default WhitelabelList
